import { render, staticRenderFns } from "./ticket-list.vue?vue&type=template&id=01c9f14c"
import script from "./ticket-list.vue?vue&type=script&lang=js"
export * from "./ticket-list.vue?vue&type=script&lang=js"
import style0 from "./ticket-list.vue?vue&type=style&index=0&id=01c9f14c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01c9f14c')) {
      api.createRecord('01c9f14c', component.options)
    } else {
      api.reload('01c9f14c', component.options)
    }
    module.hot.accept("./ticket-list.vue?vue&type=template&id=01c9f14c", function () {
      api.rerender('01c9f14c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/customer-service/ticket-list.vue"
export default component.exports